module.exports = __webpack_public_path__ + "static/media/1009875.eda403a1.jpg";